var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.displayClass},_vm._l((_vm.srArray),function(number,i){return _c('span',{key:i},[_vm._v(" "+_vm._s(number)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }